/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;height:100%;padding-left:8px}.first-line[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.first-line[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--toggle-icon-color);font-size:9px;cursor:pointer}.object-item[_ngcontent-%COMP%]{padding-left:10px}.item-key[_ngcontent-%COMP%], .item-value-simple[_ngcontent-%COMP%]{display:inline-block;vertical-align:top}.glyphicons[_ngcontent-%COMP%]:before{padding:1px}\n/*# sourceMappingURL=feature-geojson-unit.component.css.map*/"];
export { styles as styles };
